window.$ = window.jQuery = require("jquery");

// window.$(() => {
//   setTimeout(() => {
//     window.$("#dvLoading").addClass("display_none");
//   }, 00);
//  window.$(".highcharts-legend-item text").attr("y", "10");
// });
